export default __webpack_public_path__ + "static/media/man-blur-match-queue.4f95ffe4.webp";